var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 25,
    viewBox: "0 0 35 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 12.5V12.52",
    stroke: "#6C63FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6562 6.84424C25.156 8.34446 25.9985 10.3789 25.9985 12.5002C25.9985 14.6216 25.156 16.656 23.6562 18.1562",
    stroke: "#6C63FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3145 1.18604C30.8003 2.67178 31.9789 4.43565 32.783 6.37691C33.5872 8.31817 34.001 10.3988 34.001 12.5C34.001 14.6013 33.5872 16.6819 32.783 18.6232C31.9789 20.5644 30.8003 22.3283 29.3145 23.814",
    stroke: "#6C63FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3364 18.1562C10.8367 16.656 9.99414 14.6216 9.99414 12.5002C9.99414 10.3789 10.8367 8.34446 12.3364 6.84424",
    stroke: "#6C63FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.67486 23.814C5.18904 22.3283 4.01041 20.5644 3.20629 18.6232C2.40216 16.6819 1.98828 14.6013 1.98828 12.5C1.98828 10.3988 2.40216 8.31817 3.20629 6.37691C4.01041 4.43565 5.18904 2.67178 6.67486 1.18604",
    stroke: "#6C63FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWan);
export default __webpack_public_path__ + "static/media/icon-wan.0b7122a3e2437552ec7d886b32c57aba.svg";
export { ForwardRef as ReactComponent };